export default {
  title: 'Bestelling nr. {{number}}',
  labels: {
    item: '{{count}} artikel',
    item_other: '{{count}} artikelen',
  },
  buttons: {
    details: 'Details',
  },
  fulfillment_statuses: {
    created: 'Aangemaakt',
    reviewed: 'Beoordeeld',
    accepted: 'Geaccepteerd',
    preparing: 'In bereiding',
    ready: 'Klaar',
    on_delivery: 'Onderweg',
    picked: 'Opgehaald',
    rejected: 'Afgewezen',
  },
};
